if (!customElements.get("custom-summary")) {
  class CustomSummary extends HTMLElement {
    constructor() {
      super();
      // Initialize elements
      this.navigation = this.querySelector("[data-navigation]");
      this.hamburger = this.querySelector("[data-hamburger]");
      this.panel = this.querySelector("[data-panel]");

      this.navItems = document.querySelectorAll("[data-nav-item]");
      this.subtitles = document.querySelectorAll("[data-content] h2");

      this.state = false;
      this.currentIndex = 0;

      // Add event listener for hamburger menu toggle
      this.hamburger.addEventListener("click", () => {
        this.toggle();
      });

      // Render navigation list items for each subtitle
      if (this.navItems.length === 0) {
        this.subtitles.forEach((subtitle) => {
          this.renderList(subtitle.textContent);
        });
      }

      // Get all list items and enable scroll functionality
      this.scrollToElement();

      // Highlight the active navigation item according to the observed subtitles
      this.highlightActiveNavItem();
    }

    // Render a list item in the navigation
    renderList(text) {
      let navItem = document.createElement("li");
      navItem.setAttribute("data-nav-item", "");
      navItem.textContent = text;
      this.navigation.append(navItem);

      // Get all list items and enable scroll functionality
      this.scrollToElement();
    }

    // Add click event listeners to scroll to the corresponding subtitle
    scrollToElement() {
      this.navItems = this.querySelectorAll("[data-nav-item]");
      this.navItems.forEach((item, index) => {
        item.addEventListener("click", () => {
          // Remove active state from all items
          this.navItems.forEach((l) => l.removeAttribute("data-active"));

          // Close navigation on smaller screens
          if (screen.width < 1024) {
            this.toggle();
          }

          // Set active state for the clicked item
          item.setAttribute("data-active", "true");

          // Scroll to the corresponding subtitle
          const scrollToElement = this.subtitles[index];
          const yOffset = -220; // Offset for fixed header
          const y =
            scrollToElement.getBoundingClientRect().top +
            window.scrollY +
            yOffset;
          window.scrollTo({ top: y, behavior: "smooth" });
        });
      });
    }

    // Toggle the navigation panel and hamburger icon
    toggle() {
      if (!this.state) {
        // Change hamburger icon to close icon
        this.hamburger.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M6 18L18 6M6 6L18 18" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`;
        this.navigation.setAttribute("data-open", !this.state);
        this.panel.setAttribute("data-open", !this.state);
      } else {
        // Change close icon back to hamburger icon
        this.hamburger.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M3.75 9H20.25M3.75 15.75H20.25" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`;
        this.panel.setAttribute("data-open", !this.state);
        this.navigation.setAttribute("data-open", !this.state);
      }
      this.state = !this.state;
    }

    // Highlight the active navigation  according to observed subtitles
    highlightActiveNavItem() {
      const observerOptions = {
        root: null, // Use the viewport as the root
        rootMargin: "0px",
        threshold: 0.5, // Trigger when 50% of the subtitle is visible
      };

      const observerCallback = (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = Array.from(this.subtitles).indexOf(entry.target);
            this.currentIndex = index;

            // Update active state in the navigation list
            this.navItems.forEach((item, idx) => {
              if (idx === this.currentIndex) {
                item.setAttribute("data-active", "true");
              } else {
                item.removeAttribute("data-active");
              }
            });
          }
        });
      };

      const observer = new IntersectionObserver(
        observerCallback,
        observerOptions,
      );

      // Observe each subtitle
      this.subtitles.forEach((subtitle) => observer.observe(subtitle));
    }
  }

  customElements.define("custom-summary", CustomSummary);
}

if (!customElements.get("new-article-faq-item")) {
  class ArticleFaqItem extends HTMLElement {
    constructor() {
      super();

      this.addEventListener("click", () => {
        this.setAttribute("data-expand", this.dataset.expand !== "true");
      })

    }
  }

  customElements.define("new-article-faq-item", ArticleFaqItem);
}
